import { async } from "q";
import axiosClient from "./axiosClient";

const pharmacyStoreService = {
  /// Kho dược
  getListPharmacyInStore: async (params) => {
    const url = `store/medicine-store/searchKey`;

    const response = await axiosClient.get(url, {
      params: params,
    });
    return response.data;
  },
  // export
exportExcelBidDecision: async (params) => {
  const url = `store/dau-thau/export/dau-thau`;
  const response = await axiosClient.get(url, { params: params, responseType: 'blob' });
  console.log("exportExcelBidDecision", response.data);
  return response.data;
},
  //date import 
  getNgayImport: async (params) => {
    const url = `store/dau-thau/ngay-import`;
    const response = await axiosClient.get(url);
    console.log("getNgayImport", response.data);
    return response.data;
  },
  // Delete import 
  deleteNgayImport: async (selectedDates) => {
    const url = `store/dau-thau/xoa-theo-ngay-import`;
    const response = await axiosClient.delete(url, {
      data:  selectedDates  // Assuming the backend expects a property named 'ngayImport'
    });
    console.log("deleteNgayImport", response.data);
    return response.data;
  },
  getListPharmacy: async (page, pageSize) => {
    const url = `store/medicine/list-medicine`;
    const params = {
      page: page,
      limit: pageSize,
    };
    const response = await axiosClient.get(url, {
      params: params,
    });
    return response.data;
  },
  getListPharmacyInDuTruPT: async (start, end) => {
    const url = `store/receipt/phieu-du-tru-thuoc?start=${start}&end=${end}`;

    const response = await axiosClient.get(url);
    return response.data;
  },
  getCanhBaoXuatNhap: async (params) => {
    const url = `store/receipt/canh-bao-phieu-nhap`;
    const response = await axiosClient.get(url);
    return response.data;
  },

  getPharmacy: async (id, khoId = null) => {
    const url = `store/medicine/by-id`;
    const params = {
      id: id,
      khoId: khoId
    };
    const response = await axiosClient.get(url, {
      params: params,
    });
    return response.data;
  },
  getListPharmacyGroup: async (page, pageSize) => {
    const url = `store/medicine-group/list-medicine-group`;
    const params = {
      page: page,
      limit: pageSize,
    };
    const response = await axiosClient.get(url, {
      params: params,
    });
    return response.data;
  },
  getListPharmacyType: async (page, pageSize) => {
    const url = `store/medicine-type/list-medicine-type`;
    const params = {
      page: page,
      limit: pageSize,
    };
    const response = await axiosClient.get(url, {
      params: params,
    });
    return response.data;
  },
  getListPharmacyExport: async (page, pageSize) => {
    const url = `store/receipt/groups-thuoc`;
    const params = {
      page: page,
      limit: pageSize,
    };
    const response = await axiosClient.get(url, {
      params: params,
    });
    return response.data;
  },
  getThongKeThuoc: async (params) => {
    const url = `store/medicine-store/thong-ke`;
    const response = await axiosClient.get(url, {
      params: params,
    });
    return response.data;
  },
  getReportFile: async (params) => {
    const url = `store/medicine-store/export-ton-kho`;
    const response = await axiosClient.get(url, { params: params, responseType: 'blob' });
    return response.data;
  },
  getLichSuXuatNhapByIdLo: async soLo => {
    const url = "/store/medicine-store/by-id";
    const params = { id: soLo, isXemLichSu: true };
    const res = await axiosClient.get(url, { params: params });
    return res.data;
  },
  // Chi tiết phiếu

  getListUnitByThuocId: async (id) => {
    const url = `store/medicine/get-unit-by-id`;
    const params = { id: id };
    const response = await axiosClient.get(url, {
      params: params,
    });
    return response.data;
  },
  //Xuất nhập
  getListReceipt: async (params) => {
    const url = `store/receipt/search-key/groups-thuoc`;

    const response = await axiosClient.get(url, {
      params: params,
    });
    return response.data;
  },
  getDetailReceipt: async (id) => {
    const url = `store/receipt/groups-thuoc/by-id`;
    const params = { id: id };
    const response = await axiosClient.get(url, {
      params: params,
    });
    return response.data;
  },
  postImportForm: async (params) => {
    const url = "store/receipt/groups-thuoc";
    const response = await axiosClient.post(url, params);
    return response.data;
  },
  updateImportForm: async (params) => {
    const url = "store/receipt/groups-thuoc";
    const response = await axiosClient.put(url, params);
    return response.data;
  },
  // catalog
  getListManufactor: async (page = 1, limit = 10) => {
    const url = "store/manufacturer/groups-thuoc";
    const params = { page: page, limit: limit };
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
  editManufactor: async (params) => {
    const url = "store/manufacturer/groups-thuoc";
    const response = await axiosClient.put(url, params);
    return response.data;
  },
  addManufactor: async (params) => {
    const url = "store/manufacturer/groups-thuoc";
    const response = await axiosClient.post(url, params);
    return response.data;
  },
  deleteManufactor: async (id) => {
    const url = "store/manufacturer/delete";
    const params = { id: id };
    const response = await axiosClient.delete(url, { params: params });
    return response.data;
  },

  getListSupplier: async (page = 1, limit = 10) => {
    const url = "store/supplier/list-supplier";
    const params = { page: page, limit: limit };
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
  editSupplier: async (params) => {
    const url = "store/supplier/groups-thuoc";
    const response = await axiosClient.put(url, params);
    return response.data;
  },
  addSupplier: async (params) => {
    const url = "store/supplier/groups-thuoc";
    const response = await axiosClient.post(url, params);
    return response.data;
  },
  deleteSupplier: async (id) => {
    const url = "store/supplier/delete";
    const params = { id: id };
    const response = await axiosClient.delete(url, { params: params });
    return response.data;
  },
  // bao che
  getDangBaoChe: async () => {
    const url = "store/dau-thau/select/dang-bao-che";
    const response = await axiosClient.get(url);
    return response.data;
  },
  // Catalog Hoạt chất
  getListSubstance: async (page = 1, limit = 10, name = '') => {
    const url = "store/active-substance/list-active-substance";
    const params = { page: page, limit: limit, name: name };
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
  editSubstance: async (params) => {
    const url = "store/active-substance/update";
    const response = await axiosClient.put(url, params);
    return response.data;
  },
  addSubstance: async (params) => {
    const url = "store/active-substance/create";
    const response = await axiosClient.post(url, params);
    return response.data;
  },
  deleteSubstance: async (id) => {
    const url = "store/active-substance/delete";
    const params = { id: id };
    const response = await axiosClient.delete(url, { params: params });
    return response.data;
  },

  // Catalog Thuốc
  getListMedicine: async (page, limit) => {
    const url = "store/medicine/list-medicine";
    const params = { page: page, limit: limit };
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
  getListMedicineByParams: async (page, limit, tenThuoc = '') => {
    const url = "store/medicine/list-medicine/by-params-page";
    const params = { page: page, limit: limit, tenThuoc: tenThuoc };
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
  getListMedicineByAllParams: async (params) => {
    const url = "store/medicine/list-medicine/by-params-page";
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
  editMedicine: async (params) => {
    const url = "store/medicine/update";
    const response = await axiosClient.put(url, params);
    return response.data;
  },
  addMedicine: async (params) => {
    const url = "store/medicine/create";
    const response = await axiosClient.post(url, params);
    return response.data;
  },
  deleteMedicine: async (id) => {
    const url = "store/medicine/delete";
    const params = { id: id };
    const response = await axiosClient.delete(url, { params: params });
    return response.data;
  },
  // Catalog Loại thuốc
  getListMedicineType: async (page = 1, limit = 10) => {
    const url = "store/medicine-type/list-medicine-type";
    const params = { page: page, limit: limit };
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
  editMedicineType: async (params) => {
    const url = "store/medicine-type/update";
    const response = await axiosClient.put(url, params);
    return response.data;
  },
  addMedicineType: async (params) => {
    const url = "store/medicine-type/create";
    const response = await axiosClient.post(url, params);
    return response.data;
  },
  deleteMedicineType: async (id) => {
    const url = "store/medicine-type/delete";
    const params = { id: id };
    const response = await axiosClient.delete(url, { params: params });
    return response.data;
  },

  // Catalog Nhoom thuốc
  getListMedicineGroup: async (page = 1, limit = 10) => {
    const url = "store/medicine-group/list-medicine-group";
    const params = { page: page, limit: limit };
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
  editMedicineGroup: async (params) => {
    const url = "store/medicine-group/update";
    const response = await axiosClient.put(url, params);
    return response.data;
  },
  addMedicineGroup: async (params) => {
    const url = "store/medicine-group/create";
    const response = await axiosClient.post(url, params);
    return response.data;
  },
  deleteMedicineGroup: async (id) => {
    const url = "store/medicine-group/delete";
    const params = { id: id };
    const response = await axiosClient.delete(url, { params: params });
    return response.data;
  },

  // Quyết định thầu
  getListBidDecision: async (pageNum , pageSize ) => {
    const url = `store/dau-thau/findPage?pageNum=${pageNum}&pageSize=${pageSize}`;
    const response = await axiosClient.post(url);
    return response.data;
  },
  editBidDecision: async (params) => {
    const url = "store/dau-thau/createOrUpdate";
    const response = await axiosClient.post(url, params);
    return response.data;
  },
  addBidDecision: async (params) => {
    const url = "store/dau-thau/createOrUpdate";
    const response = await axiosClient.post(url, params);
    return response.data;
  },
  deleteBidDecision: async (id) => {
    const url = `store/dau-thau/delete/dau-thau?id=${id}`;
    const params = { id: id };
    const response = await axiosClient.delete(url, { params: params });
    return response.data;
  },
  getListBidDecisionByMedicineParams: async (params) => {
    const url = "store/dau-thau-thuoc/findByMedicineId";
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },

  // Catalog Kho
  getListStore: async (page = 1, limit = 10,) => {
    const url = "store/store/groups-thuoc";
    const params = { page: page, limit: limit };
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
  getListStorePhanQuyen: async (page = 1, limit = 10,) => {
    const url = "store/store/groups-thuoc?isPhanQuyen=true";
    const params = { page: page, limit: limit };
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
  editStore: async (params) => {
    const url = "store/store/groups-thuoc";
    const response = await axiosClient.put(url, params);
    return response.data;
  },
  addStore: async (params) => {
    const url = "store/store/groups-thuoc";
    const response = await axiosClient.post(url, params);
    return response.data;
  },
  deleteStore: async (id) => {
    const url = "store/store/delete";
    const params = { id: id };
    const response = await axiosClient.delete(url, { params: params });
    return response.data;
  },

  getListUnitByPharmacy: async (id) => {
    const url = `store/unit-conversion/by-thuoc-id?thuoc-id=${id}`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  getListUnit: async (page, limit) => {
    const url = `store/unit-conversion/list-unit-conversion`;
    const params = { page: page, limit: limit };
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },

  postImportForm: async (params) => {
    const url = "store/receipt/groups-thuoc";
    const response = await axiosClient.post(url, params);
    return response.data;
  },
  editImportForm: async (params) => {
    const url = "store/receipt/groups-thuoc";
    const response = await axiosClient.put(url, params);
    return response.data;
  },
  getDetailLo: async (soLo, khoId) => {
    const url = `store/medicine-store/by-so-lo?so-lo=${soLo}&-kho-id=${khoId}`;

    const response = await axiosClient.get(url);
    return response.data;
  },
  updateDetailLo: async (params) => {
    const url = "/store/medicine-store/update";
    const res = await axiosClient.put(url, params);
    return res.data;
  },
  getListLoByMedicineName: async (name, khoId) => {
    const url = `store/medicine-store/by-ten-thuoc?ten-thuoc=${name}&kho-id=${khoId}`;

    const response = await axiosClient.get(url);
    return response.data;
  },
 uploadFileThau: async (data) => {
  const url = `store/dau-thau/dau-thau/import`;
  const headers = { "Content-Type": "multipart/form-data" };
  const response = await axiosClient.post(url, data, {
    headers: headers,
  });
  return response.data;
},
};

const allocationMedicineService = {
  getList: async (params) => {
    const url = `store/prescription/paging-allocation`;
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
  allocationMedicine: async (params) => {
    const url = `store/prescription/prescription-allocation-sales`;
    const response = await axiosClient.put(url, params);
    return response.data;
  },
}
const catalogMedicineStoreService = {
  getListStore: async (page, limit, isKhoAo = 'true') => {
    const url = `store/store/groups-thuoc`;
    const params = { page: page, limit: limit, isKhoAo: isKhoAo }
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
  addStore: async (params) => {
    const url = `store/store/groups-thuoc`;
    const response = await axiosClient.post(url, params);
    return response.data;
  },
  updateStore: async (params) => {
    const url = `store/store/groups-thuoc`;
    const response = await axiosClient.put(url, params);
    return response.data;
  },
  getListMedicineGroup: async (page = 1, limit = 10) => {
    const url = "store/medicine-group/list-medicine-group";
    const params = { page: page, limit: limit };
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },

}
const inventoryMedicineStoreService = {
  getListInventory: async (params) => {
    const url = `store/kiem-ke/paging`;
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
  getDetailInventory: async (id) => {
    const url = `store/kiem-ke/by-id`;
    const params = { id: id }
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
  getStoreData: async (khoId) => {
    const url = `store/kiem-ke/get-store-data`;
    const params = { khoId: khoId }
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
  postPhieu: async (params) => {
    const url = `store/kiem-ke/create`;
    const response = await axiosClient.post(url, params);
    return response.data;
  },
  updatePhieu: async (params) => {
    const url = `store/kiem-ke/update`;
    const response = await axiosClient.put(url, params);
    return response.data;
  },


}
export default pharmacyStoreService;
export { allocationMedicineService, catalogMedicineStoreService, inventoryMedicineStoreService }



